<template>
  <div class="content has_breadcrumb">
    <edoovo-table
      height="100%"
      ref="multipleTable"
      :data="usersData.tableData"
      rowKey="id"
      :title="$route.query.className"
      defaultValue="-"
      class="list-tableBox"
      :v-loading="usersData.isLoading"
      @sortChange="_onSortChange"
      :sort="usersData.sort"
    >
      <!-- ===== -->
      <!-- 空状态 -->
      <!-- ===== -->
      <div slot="empty" style="text-align: center">
        <div
          style="
            width: 213px;
            text-align: center;
            border-radius: 50%;
            margin-bottom: 12px;
            line-height: 200px;
          "
        >
          <img style="width: 100%" :src="require('@/assets/images/products/noData.svg')" />
        </div>
        <p style="font-size: 22px">No student yet.</p>
      </div>
      <!-- ======= -->
      <!-- 分页组件 -->
      <!-- ======= -->
      <edoovo-pagination
        slot="pagination"
        @size-change="_pageSizeChange"
        @current-change="_pageChange"
        :current-page="query.current"
        :page-size="query.size"
        :total="usersData.totalNum"
      />
      <!-- ====== -->
      <!-- 筛选组件 -->
      <!-- ====== -->
      <div v-if="filterRenderData.length" class="list-filterBox" slot="filter">
        <base-filter
          ref="tablefilter"
          @filterCallback="_filterCallback"
          :renderData="filterRenderData"
          :multKeys="multKeys"
        />
      </div>

      <!-- =========== -->
      <!-- 每一项column -->
      <!-- =========== -->
      <!--  <edoovo-table-column v-slot="{ row }" size="M" label="No.">
	    {{row.dataIndex+1}}
	  </edoovo-table-column> -->
      <edoovo-table-column
        size="L"
        label="Students name"
        prop="studentName"
        sortName="Students name"
        :getTooltipText="(row) => `${row.studentName}`"
        v-slot="{ row }"
      >
        <div class="table-cell-box" @click="toDetail(row)">
          <div class="statusImg">
            <head-img
              class="table-cell-img"
              :src="row.photo ? `${row.photo}` : ``"
              :firstName="`${row.studentFirstName}`"
              :lastName="`${row.studentLastName}`"
              line-height="32"
            />
          </div>

          <span class="table-cell-name">{{ row.studentName }}</span>
        </div>
      </edoovo-table-column>
      <edoovo-table-column
        size="S"
        label="Attendance"
        prop="checkIn"
        v-slot="{ row }"
        align="center"
      >
        <span v-if="row.attendance === 0">-</span>
        <i
          class="el-icon-circle-check"
          style="font-size: 24px; color: #3db175"
          v-if="row.attendance === 1"
        ></i>
        <i
          class="el-icon-circle-close"
          style="font-size: 24px; color: #ff7d72"
          v-if="row.attendance === 2"
        ></i>
      </edoovo-table-column>
      <edoovo-table-column
        size="S"
        label="Check in"
        prop="checkIn"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.checkinTime ? row.checkinTime : ''}`"
      >
        {{ row.checkinTime || '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="Temperature"
        prop="checkinTemperature"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.checkinTemperature ? row.checkinTemperature : '-'}`"
      >
        {{ row.checkinTemperature ? row.checkinTemperature + '°C' : '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="In class"
        prop="checkinTemperature"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.inClassTime ? row.inClassTime : '-'}`"
      >
        {{ row.inClassTime ? row.inClassTime : '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="Temperature"
        prop="checkinTemperature"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.inClassTemperature ? row.inClassTemperature : '-'}`"
      >
        {{ row.inClassTemperature ? row.inClassTemperature + '°C' : '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="S"
        label="Check out"
        prop="checkOut"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.checkoutTime}`"
      >
        {{ row.checkoutTime || '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="Temperature"
        prop="checkoutTemperature"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.checkoutTemperature}`"
      >
        <!-- {{ row.checkoutTemperature+'°C' || "-" }} -->
        {{ row.checkoutTemperature ? row.checkoutTemperature + '°C' : '-' }}
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="Health check"
        prop="type"
        v-slot="{ row }"
        align="center"
        :tooltip="false"
      >
        <span v-if="row.healthCheckTime == 0">-</span>

        <el-tooltip
          popper-class="edoovo-table-cell-tooltip"
          :content="`${row.healthCheckTime > 1 ? row.healthCheckTime + ' health check records' : '1 health check record'}`"
          v-else
        >
          <i
            class="icon iconfontNew icona-SymptomsIcon_24dp"
            style="font-size: 24px; cursor: pointer"
          ></i
        ></el-tooltip>
      </edoovo-table-column>
      <edoovo-table-column
        size="M"
        label="Remarks"
        prop="type"
        align="center"
        v-slot="{ row }"
        :getTooltipText="(row) => `${row.remarks > 1 ? row.remarks + ' remarks' : '1 remark'}`"
        :tooltip="false"
      >
        <span v-if="row.remarks == 0">-</span>

        <el-tooltip
          popper-class="edoovo-table-cell-tooltip"
          :content="`${row.remarks > 1 ? row.remarks + ' remarks' : '1 remark'}`"
          v-else
          ><i
            class="icon iconfontNew icona-RemarkIcon_24dp"
            style="font-size: 24px; cursor: pointer"
          ></i
        ></el-tooltip>
      </edoovo-table-column>
      <!-- <edoovo-table-column size="L"> </edoovo-table-column> -->
      <!-- ====== -->
      <!-- action -->
      <!-- ====== -->
    </edoovo-table>
    <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />
    <!-- dialog -->

    <md-dialog-confirm
      :md-active.sync="absentDialogVisible"
      md-title="Mark as absent?"
      md-content="The student's status will change from no attendance to absent."
      md-confirm-text="Submit"
      md-cancel-text="Cancel"
      @md-cancel="() => {}"
      @md-confirm="onSaveAbsent"
    />
  </div>
</template>

<script>
import { Ajax, Utils, Auth } from '@/common'
import { readState, saveDraft, listState } from '@/common/nav-state'
import { mapState } from 'vuex'
import moment from 'moment'

// URL 读出的 current/size 只接受正整数；垃圾值回退默认值，保证内存值与请求体是 number
function toPageInt(value, fallback) {
  const n = Number(value)
  return Number.isInteger(n) && n > 0 ? n : fallback
}

// 出勤状态/排序字段白名单：URL 带入的垃圾值回退默认，不流入请求体（sortName 直通后端 ORDER BY）
const STATUS_VALUES = ['1', '2']
const SORT_FIELDS = ['Students name']
const SORT_TYPES = ['asc', 'desc']

export default {
  name: 'AttendanceStudent',
  components: {},
  watch: {
    // 同路由 A→B 复用（back/forward）：身份相关取数按新身份重取，过期响应按请求身份丢弃
    '$route.query.classId'() {
      this._resyncFromRoute()
    },
    // 浏览器前进/后退复用组件：URL 与本页最近导航不一致时按 URL 重新播种并重查；
    // 与身份 watcher 共用重同步入口（self-skip），一次导航恰好 1 次取数
    '$route.query': {
      deep: true,
      handler() {
        this._resyncFromRoute()
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    isToday() {
      return this.nowDate == this.query.date
    }
  },
  data() {
    return {
      timeData: {},
      healthCheckList: [],
      chooseStudentItem: {},
      checkInDialogVisible: false,
      checkOutDialogVisible: false,
      temperatureDialogVisible: false,
      absentDialogVisible: false,
      nowDate: '',
      query: {
        size: 20,
        current: 1,
        status: null,
        date: '',
        classId: '',
        schoolId: '',
        locationId: Auth.getLocationId() || ''
      },
      menuDatas: [
        {
          name: 'Attendance',
          key: '0',
          active: true,
          children: [
            {
              name: 'Daily',
              key: ''
            }
          ]
        }
      ],
      activeIndex: '',
      usersData: {
        ref: 'usersTable',
        totalNum: 0,
        sort: { name: '', type: '' },
        isLoading: false,
        tableTitle: 'Active Staff',
        tableData: []
      },
      filterRenderData: [
        { title: 'Student name', filterKey: 'studentName', type: 'input' },
        {
          title: 'Attendance',
          filterKey: 'status',
          type: 'radio',
          radioData: [
            { key: 'Absent', value: 2 },
            { key: 'Present', value: 1 }
          ]
        }
        // {
        //   title: "Symptoms",
        //   filterKey: "symptoms",
        //   type: "checkbox",
        //   checkboxData: [
        //     { key: "Cough", value: "Cough" },
        //     { key: "Runny Nose", value: "Runny Nose" }
        //   ]
        // }
      ],
      multKeys: [],
      snackbarData: {
        visible: false,
        content: ''
      },
      rowsForIdentity: '' // tableData 归属的路由身份（getStudentListBy* 请求身份）
    }
  },
  created() {
    // 缺失 classId 且无 schoolId 兜底与详情页同契约：提示并回班级列表，不再空身份取数（Ruling R42/R43）
    if (!this._guardRouteIdentity()) return
    this.$emit('changeDate', 'datePicker')
    this._applyRouteIdentity()
    this.filterRenderData.push({
      title: 'Symptoms',
      filterKey: 'symptoms',
      type: 'checkbox',
      checkboxData: this.healthCheckList
    })
    // 列表态以 URL 为准；缺失的默认键只回填一次（router.replace）。
    // 身份键（classId/schoolId/className）不在列表态键内，克隆合并语义原样保留。
    // date 播种序（R48）：URL（可解析）> 偏好 sessionStorage 'date'（可解析）> 今天。
    const state = listState.defaultsFrom(this.$router, this.$route, {
      current: '1',
      size: '20',
      date: this._seedDate(this.$route.query.date)
    })
    this._seedFromQuery(state)
    this._navState = this._normalizeNavState(state)
    this._navIdentity = this._routeIdentity()
    this.nowDate = Utils.formatTime(Date.now(), '{y}-{m}-{d}')
    this.getData()
    this.queryHealthCheckList()
  },
  beforeDestroy() {
    this.$emit('changeDate', '')
  },
  methods: {
    // schoolId 兜底（getStudentListBySchoolIdEnhanceV1）是已测契约，二者皆缺才视为缺参
    _guardRouteIdentity() {
      if (readState(this.$route, ['classId']) || this.$route.query.schoolId) {
        this._missingClassNotified = false
        return true
      }
      // 缺参提示/回跳每段缺失状态只做一次：身份 watcher 与列表态 watcher 同帧双触发不得双弹
      if (!this._missingClassNotified) {
        this._missingClassNotified = true
        if (this.$message) this.$message.error('Missing class')
        this.$router.replace('/classes')
      }
      return false
    },
    // 取数身份：路由 classId（school 变体时 schoolId），不回落 store（Ruling R18）
    _applyRouteIdentity() {
      this.query.classId = this.$route.query.classId || ''
      this.query.schoolId = this.$route.query.classId ? '' : this.$route.query.schoolId || ''
    },
    _requestIdentity() {
      // 取数身份含日期维度（Ruling R18/A5）：路由 class/school 身份 + attendance date——
      // 换日即换身份，旧日在途回包丢弃、旧日行拒绝写入；date 由 URL 播种后天然带维度
      const base = this._routeIdentity()
      return base ? `${base}@${this.query.date}` : ''
    },
    // 列表态导航身份（不含日期维度）：与 _requestIdentity 同 base 口径
    _routeIdentity() {
      return this.$route.query.classId || this.$route.query.schoolId || ''
    },
    // date 白名单（R48/波 2 口径）：只接受可解析值；URL > 偏好 sessionStorage 'date' > 今天，
    // 垃圾值逐级回退，绝不产生 'Invalid date' startDate
    _seedDate(raw) {
      const v = Array.isArray(raw) ? raw.find((el) => el !== undefined && el !== null) : raw
      const urlDate = v === undefined || v === null ? '' : String(v)
      if (urlDate && moment(urlDate).isValid()) return urlDate
      const pref = sessionStorage.getItem('date')
      if (pref && moment(String(pref)).isValid()) return Utils.formatTime(pref, '{y}-{m}-{d}')
      return Utils.formatTime(Date.now(), '{y}-{m}-{d}')
    },
    // 列表 URL 状态的可比对键（身份键 classId/schoolId/className 不参与）
    _stateKeys() {
      return [
        'current',
        'size',
        'date',
        'studentName',
        'status',
        'symptoms',
        'sortName',
        'sortType'
      ]
    },
    // 当前列表态 → URL patch：空值即删键（与 listState.push 同口径）
    _listPatch() {
      const patch = {}
      this._stateKeys().forEach((key) => {
        const v = this.query[key]
        patch[key] = Array.isArray(v) ? v.join(',') : v === undefined || v === null ? '' : String(v)
      })
      return patch
    },
    // 缺失/null 键折叠为 ''，保证 push 产生的"删键"与读取侧可比
    _normalizeNavState(map) {
      const out = {}
      this._stateKeys().forEach((key) => {
        const v = map[key]
        out[key] = v === undefined || v === null ? '' : String(v)
      })
      return out
    },
    _sameNavState(a, b) {
      // created 缺参早退后 _navState 可能未初始化：视为不一致，走一次正常播种
      return !!b && this._stateKeys().every((key) => a[key] === b[key])
    },
    // 自身导航统一入口：push 后记录本页最近一次 URL 状态，供 $route 监听识别自身导航
    _pushList(patch) {
      const query = listState.push(this.$router, this.$route, patch)
      this._navState = this._normalizeNavState(query)
    },
    // date 落 URL（replace 不产生新历史项）：克隆 query 保身份键（classId/schoolId/className 等），
    // 记录 _navState 供 $route 监听识别自身导航（防重查）
    _replaceDate() {
      const query = { ...this.$route.query }
      if (this.query.date) query.date = String(this.query.date)
      else delete query.date
      this.$router.replace({ path: this.$route.path, query })
      this._navState = this._normalizeNavState(query)
    },
    // 列表请求体 = f(列表态)：空选归一 null/''（与首屏口径一致）；垃圾值回退默认不入请求
    _applyListQuery(state) {
      const status = STATUS_VALUES.includes(String(state.status)) ? Number(state.status) : null
      const studentName = String(state.studentName || '')
      const symptoms = String(state.symptoms || '')
        .split(',')
        .filter((s) => s !== '')
      const sortName = SORT_FIELDS.includes(state.sortName) ? state.sortName : ''
      const sortType = SORT_TYPES.includes(state.sortType) ? state.sortType : ''
      this.query = {
        size: toPageInt(state.size, 20),
        current: toPageInt(state.current, 1),
        status: status,
        date: this._seedDate(state.date),
        classId: '',
        schoolId: '',
        locationId: Auth.getLocationId() || ''
      }
      // 身份键从路由取（同 _applyRouteIdentity 口径）：筛选重建不再丢 school 变体身份
      this._applyRouteIdentity()
      if (studentName) this.query.studentName = studentName
      if (symptoms.length) this.query.symptoms = symptoms
      // sort 仅在有效排序时携带（无键＝首屏口径）
      if (sortName && sortType) {
        this.query.sortName = sortName
        this.query.sortType = sortType
      }
      // 控件回显跟随请求体
      this.usersData.sort = { name: sortName, type: sortType }
    },
    // 以 URL 状态重建列表内存状态与筛选控件（created 与前进/后退复用共用）；BaseFilter 按新 renderData 引用回显
    _seedFromQuery(state) {
      this._applyListQuery(state)
      this.filterRenderData = this.filterRenderData.map((item) => {
        const val = this.query[item.filterKey]
        const seed = { filterVal: '', showVal: '' }
        const has = Array.isArray(val)
          ? val.length > 0
          : val !== undefined && val !== null && val !== ''
        if (has) {
          seed.filterVal = val
          seed.showVal = Array.isArray(val) ? val.join('" or "') : String(val)
        }
        return Object.assign({}, item, seed)
      })
    },
    // 身份（classId/schoolId）与列表态共用同一重同步入口：两条 watcher 先后触发也只落地一次取数
    _resyncFromRoute() {
      if (!this._guardRouteIdentity()) return
      const state = listState.read(this.$route, this._stateKeys(), {
        current: '1',
        size: '20',
        date: '',
        status: '',
        studentName: '',
        symptoms: '',
        sortName: '',
        sortType: ''
      })
      const navState = this._normalizeNavState(state)
      const identity = this._routeIdentity()
      const identityChanged = identity !== this._navIdentity
      if (!identityChanged && this._sameNavState(navState, this._navState)) return
      const prevDate = this.query.date
      this._navState = navState
      this._navIdentity = identity
      this._seedFromQuery(state)
      // P1-1/A5：换身份或换日清暂存写态（选中行/对话框/已核归属），确认框不得跨身份/跨日触发
      if (identityChanged || this.query.date !== prevDate) this._clearStagedRowState()
      this.getData()
    },
    // 换身份/换日清暂存写态（P1-1/A5）：选中行、对话框与已核行归属全部作废
    _clearStagedRowState() {
      this.chooseStudentItem = {}
      this.timeData = {}
      this.checkInDialogVisible = false
      this.checkOutDialogVisible = false
      this.temperatureDialogVisible = false
      this.absentDialogVisible = false
      this.rowsForIdentity = ''
    },
    // 行归属：选中行必须来自当前路由身份取回的表格行（R18），loading 窗口/跨班旧行拒绝写入；
    // 有行 id 时严格按 id 命名空间匹配（同生异 cio.id 不得穿透，A4），无 id 才退 studentId 比对；
    // 返回当前列表核实过的行——写载荷只用该行字段，找不到即拒绝
    _verifiedWriteRow() {
      const identity = this._requestIdentity()
      if (!identity || this.rowsForIdentity !== identity) return false
      const row = this.chooseStudentItem || {}
      return (
        this.usersData.tableData.find((item) =>
          row.id
            ? item.id === row.id
            : item === row || (row.studentId && item.studentId === row.studentId)
        ) || false
      )
    },
    _canWriteRow(requireSchool = false) {
      const row = this._verifiedWriteRow()
      // class 分支按 classId 取数，URL 额外的 schoolId 未被核实；仅 school-only 分支可回落请求校区。
      const schoolId =
        row && (row.schoolId || (!this.$route.query.classId && this.$route.query.schoolId))
      if (!row || (requireSchool && !schoolId)) {
        this.snackbarData = {
          visible: true,
          content: 'Class data is not ready yet, please try again'
        }
        return false
      }
      return row
    },
    toDetail(row) {
      // R15：先拷贝再改（data[3] 索引写非响应式，须新引用 commit 才通知）；基数组与其段对象都不被就地改写
      const data = (this.$store.state.breadcrumb.breadcrumbData || []).map((seg) => ({ ...seg }))
      // 早到竞态：subLayout 未回时基数组为空/半截，按下标改写会抛错/产出稀疏数组，先查长度
      if (data.length >= 3) {
        data[1] = { ...data[1], name: 'Classes' }
        data[2] = { ...data[2], routeName: 'classDetailInfo' }
        data[3] = {
          name: `${row.studentName}`
        }
      } else {
        data.push({ name: `${row.studentName}` })
      }
      this.$store.commit('SET_BREADCRUMDATA', data)
      const bc = saveDraft('breadcrumb', data)
      const { href } = this.$router.resolve({
        name: 'classTimeline',
        query: {
          id: row.id,
          studentId: row.studentId,
          classId: this.$route.query.classId,
          className: this.$route.query.className,
          status: row.status,
          date: row.date,
          bc: bc
        }
      })
      window.open(href, '_blank')
    },
    onChangeTopSelect(val) {
      // this.getData(val);
    },
    onDateClosed(val) {
      let tim = Date.parse(val)
      const date = Utils.formatTime(tim, '{y}-{m}-{d}')
      // date 白名单（波 2 口径）：垃圾选择回退播种链（偏好 → 今天），不产生 'Invalid date' 请求
      this.query.date = moment(String(date)).isValid() ? String(date) : this._seedDate('')
      // 换日作废（A5）：日期维度进请求/写归属身份，清选中/对话框/已核归属，
      // 旧日在途回包按请求身份丢弃，旧日行不得再写
      this._clearStagedRowState()
      this._replaceDate()
      this.getData()
    },
    onSelectedStudentItem(row, valueKey) {
      this[valueKey] = true
      this.chooseStudentItem = row
      // console.log(this.chooseStudentItem)
    },
    onCheckIn(paramsDetail) {
      // checkInOutId 是旧行 id、classId 是路由新值：必须确认行归属后才可写（Ruling R18/A4），
      // 载荷行 id/学生/校区一律取当前列表核实过的行，不一致拒绝
      const row = this._canWriteRow(true)
      if (!row) return
      let params = {
        timeLine: paramsDetail
      }
      Object.assign(params.timeLine, {
        checkInOutId: row.id,
        operation: 0,
        operationUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        schoolId: row.schoolId || this.$route.query.schoolId,
        studentId: row.studentId,
        classId: this.$route.query.classId, // '06da6a3a6aab4b0fbc38b1af4815214b',
        checkTime: moment().format('DD/MM/YYYY hh:mm A'), // '10:00:00 AM',
        userType: paramsDetail.dropUserType == 'pickup' ? 1 : 0,
        startDate: moment(moment().format('YYYY-MM-DD')).utc().format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(moment().format('YYYY-MM-DD'))
          .utc()
          .add(24, 'hours')
          .format('YYYY-MM-DD HH:mm:ss')
        // dropOffUser: '',
        // checkValue: '36.00',
        // symptoms: 'symptoms',
        // remarks: 'remarks'
      })
      params.startDate = moment(moment().format('YYYY-MM-DD')).utc().format('YYYY-MM-DD HH:mm:ss')
      params.endDate = moment(moment().format('YYYY-MM-DD'))
        .utc()
        .add(24, 'hours')
        .format('YYYY-MM-DD HH:mm:ss')
      Ajax.post('/attendance/checkInOut/checkIn', params).then((res) => {
        if (res.code === '0000') {
          this.checkInDialogVisible = false
          this.snackbarData = { visible: true, content: res.message }
          this.getData()
        }
      })
    },
    onCheckOut(paramsDetail) {
      // 同 onCheckIn：旧行 id + 新路由 classId 混源，先验行归属（Ruling R18/A4），载荷取核实行
      const row = this._canWriteRow(true)
      if (!row) return
      let params = {
        timeLine: paramsDetail
      }
      Object.assign(params.timeLine, {
        checkInOutId: row.id,
        operation: 0,
        operationUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        schoolId: row.schoolId || this.$route.query.schoolId,
        studentId: row.studentId,
        classId: this.$route.query.classId, // '06da6a3a6aab4b0fbc38b1af4815214b',
        checkTime: moment().format('DD/MM/YYYY hh:mm A'), // '10:00:00 AM',
        userType: paramsDetail.dropUserType == 'pickup' ? 1 : 0,
        status: 1
        // dropOffUser: '',
        // checkValue: '36.00',
        // symptoms: 'symptoms',
        // remarks: 'remarks'
      })
      params.startDate = moment(moment().format('YYYY-MM-DD')).utc().format('YYYY-MM-DD HH:mm:ss')
      params.endDate = moment(moment().format('YYYY-MM-DD'))
        .utc()
        .add(24, 'hours')
        .format('YYYY-MM-DD HH:mm:ss')
      Ajax.post('/attendance/checkInOut/checkOut', params).then((res) => {
        if (res.code === '0000') {
          this.checkOutDialogVisible = false
          this.snackbarData = { visible: true, content: res.message }
          this.getData()
        }
      })
    },
    temperatureeditTime(e) {
      this.timeData = e
    },
    onAddTemperature(tempValue) {
      // 同 onCheckIn：checkInOutId 来自选中行，先验行归属（Ruling R18/A4），载荷取核实行
      const row = this._canWriteRow()
      if (!row) return
      console.log(this.timeData)
      let time = moment().format('DD/MM/YYYY hh:mm A').split(' ')
      time[1] = `${this.timeData.hh}:${this.timeData.mm}`
      time[2] = this.timeData.state
      let params = {
        checkInOutId: row.id,
        operationUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        temperature: tempValue.tempValue,
        temperatureType: this.timeData.states ? 3 : 4,
        symptomsList: tempValue.paramsDetail.symptomsList,
        remarks: tempValue.paramsDetail.remarks,
        time: time.join(' ') // '10:00:00 AM'
      }
      // console.log(params)
      // return false
      Ajax.post('/attendance/timeLine/addTempV1', params).then((res) => {
        if (res.code === '0000') {
          this.temperatureDialogVisible = false
          this.snackbarData = { visible: true, content: res.message }
          this.getData()
        }
      })
    },
    onSaveAbsent(data) {
      // 业务身份 studentId+schoolId 来自选中行，先验行归属（Ruling R18/A4），载荷取核实行
      const row = this._canWriteRow(true)
      if (!row) return
      let params = {
        operationUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        schoolId: row.schoolId || this.$route.query.schoolId,
        studentId: row.studentId,
        classId: this.$route.query.classId, // '06da6a3a6aab4b0fbc38b1af4815214b'
        absentTime: moment().format('DD/MM/YYYY hh:mm A'),
        startDate: moment(moment().format('YYYY-MM-DD')).utc().format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(moment().format('YYYY-MM-DD'))
          .utc()
          .add(24, 'hours')
          .format('YYYY-MM-DD HH:mm:ss')
      }
      Ajax.post('/attendance/checkInOut/markAsAbsent', params).then((res) => {
        if (res.code === '0000') {
          this.absentDialogVisible = false
          this.snackbarData = { visible: true, content: res.message }
          this.getData()
        }
      })
    },
    toTimelinePage(row) {
      this.$router.push({
        name: 'attendanceStudentTimeline',
        query: {
          id: row.id,
          studentId: row.studentId,
          classId: this.$route.query.classId,
          className: this.$route.query.className,
          status: row.status
        }
      })
    },
    getData() {
      this.query.userId = this.user.userId
      let query = this.query
      query.startDate = moment(this.query.date).utc().format('YYYY-MM-DD HH:mm:ss')
      let url
      if (this.query.schoolId) {
        url = '/attendance/checkInOut/getStudentListBySchoolIdEnhanceV1'
      } else {
        url = '/attendance/checkInOut/getStudentListByClassIdEnhanceV1'
      }
      // 请求身份：A→B 复用时丢弃过期响应，防旧班级行覆盖新身份
      const reqId = this._requestIdentity()
      Ajax.post(url, query).then((res) => {
        if (reqId !== this._requestIdentity()) return
        let { records } = res.data
        this.usersData.tableData = records
        this.usersData.totalNum = res.data.total
        // 记录该列表归属的路由身份：写操作仅在与当前路由身份一致时可信（Ruling R18）
        this.rowsForIdentity = reqId
        // 0210cy table组件中$index不知道为什么每次都是1 研究了一会无果只能手动追加了 如有好办法删除下面的循环
        this.usersData.tableData.forEach((item, index) => {
          if (item.checkinTime) {
            item.checkinTime = moment.utc(item.checkinTime).local().format('h:mm A')
          }
          if (item.checkoutTime) {
            item.checkoutTime = moment.utc(item.checkoutTime).local().format('h:mm A')
          }
          if (item.inClassTime) {
            item.inClassTime = moment.utc(item.inClassTime).local().format('h:mm A')
          }
          item.dataIndex = index
        })
      })
    },
    queryHealthCheckList() {
      this.healthCheckList.splice(0, this.healthCheckList.length)
      Ajax.post(`/usermanage/setting/getList`, {
        dataLevel: 'healthCheck',
        dataType: 'illness',
        userId: this.user.userId
      }).then((res) => {
        res.data.forEach((item) => {
          item.key = item.value
          this.healthCheckList.push(item)
        })
      })
      Ajax.post(`/usermanage/setting/getList`, {
        dataLevel: 'healthCheck',
        dataType: 'visualCheck',
        userId: this.user.userId
      }).then((res) => {
        res.data.forEach((item) => {
          item.key = item.value
          this.healthCheckList.push(item)
        })
      })
    },
    menuSelect(key, item) {
      this.activeIndex = key
      this.query.status = key
      this.usersData.tableTitle = item.name
      this.getData()
    },
    _onSortChange(sort) {
      // 排序进 URL 并重查（sortName 白名单后才入请求体，防 URL 垃圾值直通 ORDER BY）
      this._applyListQuery(
        Object.assign(this._listPatch(), { sortName: sort.name, sortType: sort.type })
      )
      this._pushList(this._listPatch())
      this.getData()
    },
    _pageChange(val) {
      this._applyListQuery(Object.assign(this._listPatch(), { current: String(val) }))
      this._pushList(this._listPatch())
      this.getData()
    },
    _pageSizeChange(val) {
      this._applyListQuery(Object.assign(this._listPatch(), { size: String(val) }))
      this._pushList(this._listPatch())
      this.getData()
    },
    _filterCallback(data) {
      let obj = {}
      data.filter((i) => {
        obj[i.filterKey] = i.filterVal
      })
      // 筛选变更重置到第 1 页、size 回 20（旧重建口径），排序随筛选清空；date 沿用当前日期维度
      this._applyListQuery({
        current: '1',
        size: '20',
        date: this.query.date,
        status: obj.status === undefined || obj.status === null ? '' : String(obj.status),
        studentName: obj.studentName ? String(obj.studentName) : '',
        symptoms: Array.isArray(obj.symptoms) ? obj.symptoms.join(',') : '',
        sortName: '',
        sortType: ''
      })
      this._pushList(this._listPatch())
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/deep/html .md-overlay {
  /* z-index: 9!important; */
}
/deep/.table-cell-img {
  /* padding: 3px; */
  img {
    border-radius: 50%;
  }
}

.statusImg {
  display: inline-block;
  padding: 3px;
  width: 38px;
  border-radius: 50%;
  margin-right: 5px;
  /* background-color: #ddd; */
}
/deep/.previewImg {
  display: none;
}
/deep/.md-field .md-input,
.md-field .md-textarea {
  font-size: 14px;
}
/deep/.md-field label {
  font-size: 14px;
}
/deep/.ggPage-main-left {
  display: none;
}
/deep/.has_breadcrumb .ggPage-main {
  padding-top: 33px !important;
}

/deep/.edoovo-table-empty {
  padding-top: 80px;
}
/deep/.edoovo-table-box {
  padding-top: 136px !important;
  padding-bottom: 28px !important;
}
.content {
  height: 100%;
  /* padding-bottom: 60px; */
}
.content {
  position: relative;
  top: -24px;
}
/deep/.edoovo-table-pagination {
  bottom: -24px;
}
</style>
